<template>
    <div>
      <NavbarSection />
       <!-- Start -->
       <section class="py-36 md:h-auto md:py-0 flex items-center relative bg-orange-600/5 dark:bg-orange-600/10" id="home">
            <div class="container relative">
                <div class="grid grid-cols-1 text-center mt-0 md:mt-12 pt-0 md:pt-12">
                    <div class="mt-28">
                        <div>
                            <h4 class="lg:text-5xl text-4xl lg:leading-normal leading-normal font-medium mb-7 position-relative dark:text-white">Unique and bold functionality</h4>
                
                            <p class="text-slate-600 dark:text-white/70 opacity-50 mb-0 max-w-2xl text-lg mx-auto">Launch your campaign and benefit from our expertise on designing and managing conversion centered Tailwind CSS html page.</p>
                        
                            <div class="relative mt-10">
                                <a href="javascript:void(0);" class="btn bg-orange-600 hover:bg-orange-700 border-orange-600 hover:border-orange-700 text-white rounded-md">Start Free Trail !</a>
                            </div>
                        </div>

                        <img src="@/assets/images/bg/laptop.png" alt="" class="relative mt-16">
                    </div>
                </div>
            </div><!--end container-->
        </section><!--end section-->
        <!-- End -->
      <AboutSection />
      <ServiceSection />
      <PortfolioSection />
      <TestimonialSection />
      <PricingSection />
      <TeamSection />
      <BlogSection />
      <ContactSection />
      <FooterSection />
      <SwitcherSection />
    </div>
  </template>
  
  <script>
  import NavbarSection from '../components/NavbarSection.vue';
  import AboutSection from '../components/AboutSection.vue';
  import ServiceSection from '../components/ServiceSection.vue';
  import PortfolioSection from '../components/PortfolioSection.vue';
  import TeamSection from '../components/TeamSection.vue';
  import PricingSection from '../components/PricingSection.vue';
  import BlogSection from '../components/BlogSection.vue';
  import ContactSection from '../components/ContactSection.vue';
  import FooterSection from '../components/FooterSection.vue';
  import TestimonialSection from '../components/TestimonialSection.vue';
  import SwitcherSection from '../components/SwitcherSection.vue';
  
  export default {
    name: 'PageIndexFive',
    components: {
      NavbarSection,
      AboutSection,
      ServiceSection,
      PortfolioSection,
      TeamSection,
      PricingSection,
      BlogSection,
      ContactSection,
      FooterSection,
      TestimonialSection,
      SwitcherSection
    },
   
  }
  </script>
  